<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title m-subheader__title--separator">
            {{'user_administration' | translate | titleize}}
          </h3>
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
          <div class="m-form m-form--label-align-right">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class=""></i>
              </span>
              <h3 class="m-portlet__head-text">{{'profiles' | capitalize }}</h3>
            </div>
          </div>
          </div>
          <div class="m-portlet__head-tools">
            <button v-if="validPermission('create', 'profile')" id="btn-newprofile" data-toggle="modal" data-target="#profile-modal" data-backdrop="static" data-keyboard="false" class="btn btn-success m-btn m-btn--icon" @click="updateModalStatus(true)">
              <span><i class="fa fa-plus-circle"></i><span>{{'create_profile' | capitalize }}</span></span>
            </button>
          </div>
        </div>
        
        <router-view></router-view>

      </div>
      <s-new-profile></s-new-profile>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SNewProfile from '@/components/admin/profiles/New.vue'
  export default {
    components: { SNewProfile },
    computed: {
      ...mapGetters({permissions: 'getUserPermissions'})
    },
    methods: {
      ...mapActions(['updateModalStatus']),
      validPermission (action, entity) {
        if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
          return true
        } else {
          return false
        }
      }
    },
    created () {
      this.$store.dispatch('permissions')
      this.$store.dispatch('profiles')
      this.$store.dispatch('levels')
    }
  }
</script>



// WEBPACK FOOTER //
// Profiles.vue